import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-segubroder',
  templateUrl: './segubroder.component.html',
  styleUrls: ['./segubroder.component.css']
})
export class SegubroderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
